import React, { Component, Fragment } from "react";
import { Form, Radio, Input, Slider, Checkbox } from "antd";
import { observer } from "mobx-react";
import styles from "../index.module.less";

const FormItem = Form.Item;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

const marks = {
	0: "0",
	1: "1",
	2: "2",
	3: "3",
	4: "4",
	5: "5",
	6: "6",
	7: "7",
	8: "8"
};

@observer
class SpinRewriter extends Component {
	render() {
		return (
			<Fragment>
				<Form layout="vertical" className={styles.rxform}>
					<FormItem label="Email Address">
						{this.props.form.getFieldDecorator("spinRewriter.email")(
							<Input type="text" />
						)}
					</FormItem>
					<FormItem label="API Key">
						{this.props.form.getFieldDecorator("spinRewriter.apiKey")(
							<Input type="text" />
						)}
					</FormItem>
					<FormItem label="Confidence Level">
						{this.props.form.getFieldDecorator("spinRewriter.confidenceLevel")(
							<RadioGroup>
								<RadioButton value={1}>Low</RadioButton>
								<RadioButton value={2}>Medium</RadioButton>
								<RadioButton value={3}>High</RadioButton>
							</RadioGroup>
						)}
					</FormItem>
				</Form>
				<Form layout="inline">
					<FormItem>
						{this.props.form.getFieldDecorator("spinRewriter.protectedTerms", {
							valuePropName: "checked"
						})(<Checkbox>Auto Protected Terms</Checkbox>)}
					</FormItem>
					<FormItem>
						{this.props.form.getFieldDecorator("spinRewriter.paragraphs", {
							valuePropName: "checked"
						})(<Checkbox>Auto Paragraphs</Checkbox>)}
					</FormItem>
					<FormItem>
						{this.props.form.getFieldDecorator("spinRewriter.sentences", {
							valuePropName: "checked"
						})(<Checkbox>Auto Sentences</Checkbox>)}
					</FormItem>
				</Form>
				<Form layout="inline">
					<FormItem>
						{this.props.form.getFieldDecorator("spinRewriter.nestedSpintax", {
							valuePropName: "checked"
						})(<Checkbox>Nested Spintax</Checkbox>)}
					</FormItem>
					<FormItem>
						{this.props.form.getFieldDecorator("spinRewriter.newParagraphs", {
							valuePropName: "checked"
						})(<Checkbox>Auto New Paragraphs</Checkbox>)}
					</FormItem>
					<FormItem>
						{this.props.form.getFieldDecorator("spinRewriter.sentenceTrees", {
							valuePropName: "checked"
						})(<Checkbox>Auto Sentence Trees</Checkbox>)}
					</FormItem>
				</Form>
			</Fragment>
		);
	}
}

export default SpinRewriter;
